import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import CloseIcon from "@material-ui/icons/Close";
import { mdiFileExcel } from "@mdi/js";
import Icon from "@mdi/react";
import TableToExcel from "@dayalk/table-to-excel";
import axios from "axios";
import Styled from "styled-components";
import formatDate from "../../components/Control/formatDate";
import Loader from "../../components/Control/Loader";
import RevisionLog from "../Sop/RevisionLog";
import SpecialProcessExcelTable from "./SpecialProcessExcelTable";

const Table = Styled.table`
  width: 98%;
  margin: auto;
  margin-bottom: 1rem;
  border-collapse: collapse;
    th{
        font-size: 12px;
        font-family:"Roboto",sans-serif;
        border: 1px solid black;
        padding: 0.4rem;
        font-weight: bold;
    }
    td{
        font-size: 12px;
        border: 1px solid black;
        padding: 0.3rem;
    }
`;

const specHeadings = [
  "S.No.",
  "Machine",
  "Product Char.",
  "Process Char.",
  "Special Char.",
  "Spec. / Tolerance",
  "Evaluation Method",
  "Sample Size",
  "Sample Frequency",
  "RECORDING YES / NO",
  "Control Method",
  "Responsibility",
  "Reaction Plan & Action",
  "Remarks",
];

const ViewSpecialProcess = () => {
  const { id } = useParams();
  const history = useHistory();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`/api/specialProcess/revision/${id}`)
      .then((res) => setData(res.data))
      .catch((err) => console.log(err));
  }, [id]);

  if (!data) return <Loader />;

  const process = data.processes?.[0];
  const excelFileName = `Special Process - ${
    process?.process_name || process?.process_no || "Export"
  }`.replace(/[<>:"/\\|?*]/g, "-");

  return (
    <div style={{ paddingBottom: "4rem" }}>
      <div
        className="divflex"
        style={{ fontSize: "24px", justifyContent: "space-between" }}
      >
        SPECIAL PROCESS
        <div style={{ display: "flex", gap: "0.5rem", marginRight: "0.5rem" }}>
          <Tooltip arrow title="Export as spreadsheet">
            <Button
              type="button"
              variant="contained"
              size="large"
              style={{ backgroundColor: "#161a1d", color: "white" }}
              onClick={() => {
                TableToExcel.convert(
                  document.getElementById("special-process-excel-table"),
                  {
                    name: `${excelFileName}.xlsx`,
                    sheet: { name: "Special Process" },
                  },
                );
              }}
            >
              <Icon path={mdiFileExcel} size={1.2} />
            </Button>
          </Tooltip>
          <Button
            type="button"
            variant="contained"
            color="primary"
            size="large"
            style={{ backgroundColor: "red" }}
            startIcon={<CloseIcon />}
            onClick={() => history.goBack()}
          >
            Close
          </Button>
        </div>
      </div>

      <Table style={{ marginTop: "1.5rem" }}>
        <tbody>
          <tr>
            <td colSpan={4}>
              <b>Process No. : </b>
              {process?.process_no}
            </td>
            <td colSpan={4}>
              <b>Process Name : </b>
              {process?.process_name}
            </td>
            <td colSpan={3}>
              <b>Revision No. : </b>
              {data.revision_no}
            </td>
            <td colSpan={2}>
              <b>Revision Date : </b>
              {formatDate(data.date_review)}
            </td>
          </tr>
        </tbody>
      </Table>

      <Table>
        <thead>
          <tr>
            {specHeadings.map((heading) => (
              <th key={heading}>{heading}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {process?.specs?.map((spec, index) => (
            <tr key={spec._id || index}>
              <td align="center">{spec.s_no}</td>
              <td>{spec.machine}</td>
              <td>{spec.char_product}</td>
              <td>{spec.char_process}</td>
              <td align="center">{spec.special_character}</td>
              <td>{spec.control_product}</td>
              <td>{spec.methods_measure}</td>
              <td align="center">{spec.methods_size}</td>
              <td align="center">{spec.methods_by}</td>
              <td align="center">{spec.recording}</td>
              <td>{spec.methods_process}</td>
              <td>{spec.responsibility}</td>
              <td>{spec.reaction_plan}</td>
              <td>{spec.remarks}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <SpecialProcessExcelTable
        data={data}
        process={process}
        headings={specHeadings}
      />

      {data.revisionData?.length > 0 && (
        <RevisionLog revisionData={data.revisionData} />
      )}
    </div>
  );
};

export default ViewSpecialProcess;
